export const getAccessToken = state => state.accessToken;
export const getUser = state => state.user;
export const getMessage = state => state.message;
export const getMessageWithoutTimeout = state => state.messageWithoutTimeout;
export const getUserEntity = state => state.userEntity;
